module.exports = __webpack_public_path__ + "static/media/deliverTruck3.7e842759.svg";